import { render } from "./App.vue?vue&type=template&id=537394f1"
const script = {}

import "./App.vue?vue&type=style&index=0&id=537394f1&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__